import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { Checkbox, Col, Form, Row } from "antd";
import { HelpLabelDeliveryPhoto, HelpLabelDeliverySignature, HelpLabelPickupPhoto } from "../../components/HelpLabels";
import { axiosErrorHandler } from "../../../../swzutils";
import { useAppSelector } from "../../../../store";
import { selectedTenantSelector } from "../../../../store/slice/auth";
const ConsignmentRequirementsFormItems = (props) => {
    const [availableSpecialRequirements, setAvailableSpecialRequirements] = useState([]);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    useEffect(() => {
        loadSpecialRequirementOptions();
    }, []);
    useEffect(() => {
        loadSpecialRequirementOptions();
    }, [selectedTenant, props.tenantId]);
    const loadSpecialRequirementOptions = () => {
        // Use tenant ID if provided falling back to selected tenant
        const tenantId = props.tenantId || selectedTenant?.id;
        if (tenantId) {
            axios.get('/admin/v1/tenants/' + tenantId + '/special-requirements')
                .then(response => {
                setAvailableSpecialRequirements(response.data);
                if (props.onSpecialRequirementOptionsLoaded) {
                    props.onSpecialRequirementOptionsLoaded(response.data);
                }
            }).catch(axiosErrorHandler);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Form.Item, { name: "pickUpPhotoRequired", label: null, valuePropName: "checked", children: _jsx(Checkbox, { children: _jsx(HelpLabelPickupPhoto, {}) }) }), _jsx(Form.Item, { name: "completionPhotoRequired", label: null, valuePropName: "checked", children: _jsx(Checkbox, { children: _jsx(HelpLabelDeliveryPhoto, {}) }) }), _jsx(Form.Item, { name: "completionSignatureRequired", label: null, valuePropName: "checked", children: _jsx(Checkbox, { children: _jsx(HelpLabelDeliverySignature, {}) }) }), _jsx(Form.Item, { name: "specialRequirements", label: null, children: _jsx(Checkbox.Group, { style: { width: "100%" }, children: _jsx(Row, { children: availableSpecialRequirements.map(specialRequirement => {
                            return (_jsx(Col, { span: 24, style: { marginBottom: '30px' }, children: _jsx(Checkbox, { value: specialRequirement.id, children: specialRequirement.title }) }, specialRequirement.id));
                        }) }) }) })] }));
};
export default ConsignmentRequirementsFormItems;
